import React from 'react';
import { HiDownload } from 'react-icons/hi';
import { downloadFile } from '../../utils/fileDownloader';
import './DownloadButton.css';

const DownloadButton = ({ blobPath, displayName, children }) => {
  const handleDownload = () => {
    downloadFile(blobPath, displayName);
  };

  return (
    <button onClick={handleDownload} className="download-btn">
      <span className="download-title">{children || displayName}</span>
      <HiDownload className="download-icon" />
    </button>
  );
};

export default DownloadButton;